import { render, staticRenderFns } from "./DisputeIssuerComment.vue?vue&type=template&id=0564dcf8&"
import script from "./DisputeIssuerComment.vue?vue&type=script&lang=js&"
export * from "./DisputeIssuerComment.vue?vue&type=script&lang=js&"
import style0 from "./DisputeIssuerComment.vue?vue&type=style&index=0&id=0564dcf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports